<!-- 地址选择组件 -->
<template>
  <div class="map-select">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">{{ title }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="address-location">
            <!-- 搜索 -->
            <div class="search-box">
              <van-search v-model="searchKey" clearable placeholder="请输入搜索关键词" />
            </div>
            <div class="search-container">
              <div class="main-box" v-if="!searchKey">
                <!-- 地图 -->
                <div v-if="aMapObj.gps" class="map-box">
                  <div class="map" id="J_map"></div>
                  <div class="location-icon"></div>
                  <div class="location-button" @click.stop="goLocCenter"></div>
                </div>
                <div :class="['tip-list-box', { 'tip-list-box-no-gps': !aMapObj.gps }]">
                  <!-- 定位失败提示 -->
                  <p v-if="!aMapObj.gps" class="location-fail os-font-14-400">
                    定位失败，以下为推荐结果
                  </p>
                  <!-- 地址列表 -->
                  <div class="list-box">
                    <ul v-if="placeSearchResult.length">
                      <li
                        class="item-panel"
                        v-for="(item, index) in placeSearchResult"
                        :key="index"
                        @click="onResLi(item, index)"
                      >
                        <i :class="index == 0 && aMapObj.gps ? 'selected' : 'unselected'"></i>
                        <div class="item-right">
                          <span
                            class="name os-font-14-500"
                            :class="{ 'name-selected': index == 0 }"
                            >{{ item.name }}</span
                          >
                          <p class="address os-font-12-400">{{ item.address }}</p>
                        </div>
                      </li>
                    </ul>
                    <div v-else class="no-result">
                      <template v-if="loadingFlag">
                        <div class="no-info-img"></div>
                        <div class="no-info os-font-14-500">正在加载</div>
                      </template>
                      <template v-else>
                        <div class="no-info-img-search"></div>
                        <div class="no-info-search os-font-14-500">暂无结果</div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 搜索列表 -->
              <div class="search-list" :class="{ scroll: keySearchResult.length }" v-if="searchKey">
                <ul class="list-wrap" v-if="keySearchResult.length">
                  <li
                    class="item-panel"
                    v-for="(item, index) in keySearchResult"
                    :key="index"
                    @click="onResLi(item, index)"
                  >
                    <i :class="['unselected', index == currentIndex ? 'selected' : '']"></i>
                    <div class="item-right">
                      <span class="name os-font-14-500">{{ item.name }}</span>
                      <p class="address os-font-12-400">{{ item.address }}</p>
                    </div>
                  </li>
                </ul>
                <div v-else class="no-result">
                  <template v-if="loadingFlag">
                    <div v-if="keySearchResult.length == 0">
                      <div class="no-info-img-search"></div>
                      <div class="no-info-search os-font-14-500">暂无搜索结果</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="no-info-img"></div>
                    <div class="no-info os-font-14-500">正在搜索</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { debounce } from '@/utils/common'
import app from '@/utils/app'

export default {
  name: 'mapSelect',
  props: {
    title: {
      type: String,
      default: '选择取货地址'
    },
    repairAddressList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPopup: false,
      searchKey: '',
      currentIndex: ''
    }
  },
  watch: {
    searchKey(val) {
      debounce(this._keySearch, 300)()
    },
    showPopup: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          await this.initMap()
        } else {
          this.clear()
        }
      }
    }
  },
  computed: {
    ...mapState('repair', [
      'repairType',
      'aMapObj',
      'addressSelectType',
      'placeSearchResult',
      'keySearchResult',
      'loadingFlag',
      'isSameAddress'
    ])
  },
  methods: {
    ...mapMutations('repair', [
      'clearMapResult',
      'setAMapObj',
      'setMapLocationPickupAddress',
      'setMapLocationReceiveAddress',
      'setAddressAddInfo'
    ]),
    ...mapActions('repair', ['getGeocoderAddress', 'initMapCavas', 'setMapCenter', 'keySearch']),

    async initMap() {
      await this.getLocation()
      this.initMapCavas(map => {
        this.map = map
      })
    },
    clear() {
      this.searchKey = ''
      this.clearMapResult()
      this.map = null
    },
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.showPopup = false
    },
    goLocCenter() {
      if (this.aMapObj.location) {
        this.setMapCenter({ map: this.map })
      } else {
        this.getLocation().then(res => {
          if (res) {
            this.setMapCenter({ map: this.map })
          }
        })
      }
    },
    getLocation() {
      return new Promise(resolve => {
        app.getLocation(
          res => {
            // 未开启定位权限触发
            if (!res.longitude || !res.latitude) {
              resolve(null)
              return
            }
            this.setAMapObj({
              center: [res.longitude, res.latitude],
              isGps: true
            })
            resolve([res.longitude, res.latitude])
          },
          () => {
            const options = {
              enableHighAccuracy: true,
              timeout: 5000,
              maximumAge: 0
            }
            navigator.geolocation.getCurrentPosition(
              res => {
                let crd = res.coords
                this.setAMapObj({
                  center: [crd.longitude, crd.latitude],
                  isGps: true
                })
                resolve([crd.longitude, crd.latitude])
              },
              () => {
                resolve(null)
              },
              options
            )
          }
        )
      })
    },
    _keySearch() {
      this.keySearch(this.searchKey)
    },
    onResLi(item, index) {
      this.currentIndex = index
      const pos = [item.location.lng, item.location.lat]
      this.getGeocoderAddress({
        lnglat: pos,
        callback: async (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const { province, city, district, adcode, township } =
              result.regeocode?.addressComponent
            const formattedArea = Array.isArray(district)
              ? district[0] || township
              : district || township
            let detailAddress = ''
            if ((province + formattedArea).indexOf(item.address) >= 0) {
              const formattedAddress = result.regeocode?.formattedAddress || ''
              const splitArray = formattedAddress.split(formattedArea)
              if (splitArray && splitArray.length > 1) {
                splitArray.shift()
              }
              const address = splitArray.join('') || item.address
              detailAddress = address + '' + item.name
            } else {
              detailAddress = item.address + '' + item.name
            }
            const res = {
              province,
              city: city || province,
              area: formattedArea,
              detailAddress,
              citycode: adcode,
              lng: item.location.lng,
              lat: item.location.lat
            }
            if (this.repairType == 6) {
              if (this.addressSelectType == 1) {
                this.setMapLocationPickupAddress(res)
              } else {
                this.setMapLocationReceiveAddress(res)
              }
            } else {
              let res = {
                province,
                city: city || province,
                area: formattedArea,
                detailAddress
              }
              this.setAddressAddInfo(res)
            }
            this.closePopup()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-search {
  .van-search__content {
    padding-left: 0;
  }

  .van-field {
    padding: 4px 0;
  }

  .van-field__control {
    color: #333;

    &::placeholder {
      color: #999;
    }
  }

  .van-icon-search {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 24px;
      height: 24px;
      display: block;
      background: url('~@/assets/img/repair/confirm/wap/search-icon.svg') center center no-repeat;
      background-size: contain;
    }
  }

  .van-field__body {
    .van-icon-clear {
      width: 24px;
      padding-right: 4px;

      &::before {
        content: '';
        width: 24px;
        height: 24px;
        display: block;
        background: url('~@/assets/img/repair/confirm/wap/search-delete-icon.svg') center center
          no-repeat;
        background-size: contain;
      }
    }
  }
}

.popup-content {
  max-height: calc(90vh - 90px);
  height: 444px;
  overflow: hidden !important;
}

.map-select {
  .address-location {
    display: flex;
    flex-direction: column;
    height: 100%;

    .search-box {
      padding: 8px 16px;
      box-sizing: border-box;

      .vivo-dark-mode & ::v-deep .van-search {
        background-color: #282828;

        .van-search__content {
          background-color: #282828;
        }
      }

      ::v-deep .van-search {
        border-radius: 16px;
        background: rgba(216, 216, 216, 0.2);
        padding: 0 12px;

        .van-cell {
          padding: 0;
        }

        .van-field__left-icon {
          margin-right: 8px;
          display: flex;
          align-items: center;
        }

        input {
          height: 32px;
          line-height: 32px;
        }
      }
    }

    .search-container {
      position: relative;
      height: 100%;
      flex-grow: 1;
      overflow-y: auto;

      .main-box {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .map-box {
        position: relative;
        width: 100%;
        background: #f8f8f8;
        flex-shrink: 0;
        flex-grow: 0;
        margin-top: 4px;

        .map {
          width: 100%;
          height: 224px;

          ::v-deep {
            .amap-copyright {
              display: none !important;
            }
          }
        }

        .location-icon {
          position: absolute;
          width: 30px;
          height: 30px;
          background: url('~@/assets/img/repair/confirm/wap/map-icon.svg') center no-repeat;
          background-size: contain;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none; //ICON位置触发拖拽
        }

        .location-button {
          position: absolute;
          width: 30px;
          height: 30px;
          bottom: 30px;
          left: 20px;
          background: url('~@/assets/img/repair/confirm/wap/loc_gray.png') center no-repeat;
          background-size: contain;
        }
      }

      .tip-list-box {
        height: 268px;
        box-sizing: border-box;
        overflow-y: auto;

        &.tip-list-box-no-gps {
          height: 468px;
        }

        .location-fail {
          text-align: center;
          padding-top: 12px;
        }

        .list-box {
          padding: 16px 16px;

          .no-result {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 24px;

            .no-info-img {
              width: 30px;
              height: 30px;
              background: url('~@/assets/img/repair/confirm/wap/loading-white.gif') center no-repeat;
              background-size: contain;
            }

            .no-info {
              margin-top: 3px;
              color: #b2b2b2;
            }
          }

          .item-panel {
            display: flex;
            align-items: center;
            margin-bottom: 18px;

            .selected {
              display: block;
              width: 24px;
              height: 24px;
              background: url('~@/assets/img/repair/confirm/wap/map-item-select.svg') center
                no-repeat;
              background-size: contain;
            }

            .unselected {
              display: block;
              width: 24px;
              height: 24px;
              background: url('~@/assets/img/repair/confirm/wap/map-item-icon.svg') center no-repeat;
              background-size: contain;
            }

            .item-right {
              flex: 1;
              margin-left: 3px;
              font-size: 0;
            }

            .name {
              line-height: 19px;
              color: #333;
            }

            .address {
              line-height: 19px;
              color: #888;
            }
          }
        }
      }

      .search-list {
        height: 100%;
        background: #fff;
        z-index: 161; // 地图是160

        .vivo-dark-mode & {
          background-color: #1e1e1e;
        }

        &.scroll {
          height: auto;
        }

        .no-result {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .no-info-img-search {
            margin: 0 auto;
            display: block;
            width: 48px;
            height: 48px;
            background: url('~@/assets/img/repair/confirm/wap/website.svg') center center no-repeat;
            background-size: contain;
          }

          .no-info-search {
            margin-top: 12px;
            color: #b2b2b2;
          }

          .no-info-img {
            width: 30px;
            height: 30px;
            background: url('~@/assets/img/repair/confirm/wap/loading-white.gif') center no-repeat;
            background-size: contain;
          }

          .no-info {
            margin-top: 8px;
            color: #b2b2b2;
          }
        }

        .list-wrap {
          padding: 16px 16px;
        }

        .item-panel {
          display: flex;
          align-items: center;
          margin-bottom: 18px;

          .selected {
            width: 24px;
            height: 24px;
            background: url('~@/assets/img/repair/confirm/wap/map-item-select.svg') center no-repeat;
            background-size: contain;
          }

          .unselected {
            width: 24px;
            height: 24px;
            background: url('~@/assets/img/repair/confirm/wap/map-item-icon.svg') center no-repeat;
            background-size: contain;
          }

          .item-right {
            flex: 1;
            margin-left: 3px;
          }

          .name {
            line-height: 19px;
            color: #333;
          }

          .address {
            line-height: 19px;
            color: #888;
          }
        }
      }
    }
  }
}
</style>
